module.exports = __webpack_public_path__ + "static/media/employee_none.1bf3a0c0.png";